import { rankWith, uiTypeIs, LayoutProps } from '@jsonforms/core';
import {
  ResolvedJsonFormsDispatch,
  withJsonFormsLayoutProps,
} from '@jsonforms/react';
import { getElements, getLabel } from '../../../../../utils/DynamicForms';

import './style.scss';

type Props = LayoutProps;
const HorizontalLayout = (props: Props) => {

  if (!props.visible) return null;
  return (
    <div
      className={`tru-layout-horizontal-inputs align-dynamicform-buttons  ${
        !!getLabel(props.uischema) ? 'layout-without-border' : ''
      }`}
    >
      <div>
        {/* {!!getLabel(props.uischema) && <h3>{getLabel(props.uischema)}</h3>} */}
        {getElements(props.uischema).map((element, index) => (
          <ResolvedJsonFormsDispatch
            {...props}
            uischema={element}
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export const HorizontalLayoutEntry = {
  tester: rankWith(1, uiTypeIs('HorizontalLayout')),
  renderer: withJsonFormsLayoutProps(HorizontalLayout),
};
// 